import http from './http';

export default {
  all() {
    return http().get(`/v1/pipeline_views`);
  },
  get(id) {
    return http().get(`/v1/pipeline_views/${id}`);
  },
  create(data) {
    return http().post(`/v1/pipeline_views`, data);
  },
  clone(id) {
    return http().post(`/v1/pipeline_views/${id}/clone`);
  },
  update(data) {
    return http().put(`/v1/pipeline_views/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/pipeline_views/${id}`);
  },
}
